/**
 * module: FileLoadDropZoneControl.js
 * author: Rob Blanch
 * usage: rendering logic for control to receive file drop or file selection for upload
 * license: see https://www.stonylanetech.com/licenses/license.txt for details
 * 
 * (C) 2025 Stony Lane Tech LLC
 */
import React from 'react';

/**
 * class: SLTFileLoadDropZoneControl
 * usage: rendering logic for control to receive file drop or file selection for upload
 *      note: it expects to render a row within a parent HTML table (ie. <tr></tr> is returned)
 * props:
 *      name - (mandatory) name of control in html if you want different than key which is default
 *      label - (mandatory) label to apply to control (if not supplied no label displayed)
 *      onFileLoad(fileContent) - (mandatory) callback routine when file is loaded via drop or file select
 */
class SLTFileLoadDropZoneControl extends React.Component {
    /**
     * constructor
     */
    constructor(props) {
        super(props);

        var isMissingProps = true;

        /**
         * check to make sure mandatory props have been supplied
         */
        if (props.name !== undefined && props.name !== null && props.name.length > 0 &&
            props.label !== undefined && props.label !== null && props.label.length > 0 &&
            props.onFileLoad !== undefined && props.onFileLoad !== null) {
            isMissingProps = false;
        }

        /**
         * set the initial state
         */
        this.state = {
            isMissingProps: isMissingProps,
        };
    }

    /**
     * render
     *      react js called routine to render the control
     */
    render() {
        if (this.state.isMissingProps === false) {
            const handleDrop = (ev) => {
                ev.preventDefault();
                const file = ev.dataTransfer.files[0];
                if (file) {
                    this.props.onFileLoad(file);
                }
            };

            return (
                <tr className="Page_Row_Label">
                    <td className="Page_Col_Label">
                        <label htmlFor={this.props.name + '_file_input'}>{this.props.label}</label>
                    </td>
                    <td className="Page_Col">
                        <div    id={this.props.name + '_drop_zone'}
                                className="FileLoadDropZone_Ctl"
                                onDrop={handleDrop}
                                onDragOver={(ev) => ev.preventDefault()}>
                            <p>Drag/drop file or click to select file.</p>
                            <input  type="file"
                                    id={this.props.name + '_file_input'}
                                    name={this.props.name + '_file_input'}
                                    className="FileLoadDropZone_FileInput"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            this.props.onFileLoad(file);
                                        }
                                    }} />
                        </div>
                    </td>
                </tr>
            );
        } else {
            return(
                <tr className="Page_Row_Label">
                    <td className="Page_Col">
                        <p>SLTFileLoadDropZoneControl missing mandatory props. Check rendered SLTFileLoadDropZoneControl.</p>
                    </td>
                </tr>
            );
        }
    }
}

export default SLTFileLoadDropZoneControl;